import {useRecoilValue} from "recoil";
import {selectedColonicalTableauId} from "../../../recoils/recoil";
import {useGetTableaurecordsByTableauId} from "./useGetTableaurecordsByTableauId";
import React from "react";

const Tableau = ({backToToc}) => {

    const tableauId = useRecoilValue(selectedColonicalTableauId);
    const {data} = useGetTableaurecordsByTableauId(tableauId);

    const renderHeader = () => {
        return (
            <div className="list-row table-title">
                {data.metadata.columns.map((column, index) => (
                    <div
                        key={index}
                        className={`th ${column.toLowerCase().includes('校名') ? 'school' :
                            column.toLowerCase().includes('所在地') ? 'location' : ''}`}
                    >
                        {column}
                    </div>
                ))}
            </div>
        );
    };

    const renderRows = () => {
        return data.records.map((record, index) => (
            <div key={index} className="list-row">
                {data.metadata.columns.map((column, colIndex) => {

                    const zhValue = record.data_zh[column];

                    const koSchoolName = record.data_ko["학교명"];
                    const koLocation = record.data_ko["소재지"];


                    // 학교명(한자, 한글)
                    if (column.toLowerCase().includes('校名')) {
                        return (
                            <div key={colIndex} className="th school">
                                <span className="bold c-black">{zhValue}</span>
                                <span>{koSchoolName}</span>
                            </div>
                        );
                    }

                    // 소재지(한자, 한글)
                    if (column.toLowerCase().includes('所在地')) {
                        return (
                            <div key={colIndex} className="td location">
                                <span className="c-black">{zhValue}</span>
                                <span>{koLocation}</span>
                            </div>
                        );
                    }

                    // 세미콜론을 기준으로 줄바꿈 처리
                    const formattedZhValue = (typeof zhValue === 'string' && zhValue.includes(';'))
                        ? zhValue.split(';').map((item, itemIndex) => {
                            const parts = item.trim().split(':').map(part => part.trim());
                            const formattedParts = parts.map((part, partIndex) => {
                                // 숫자 부분에는 c-black 클래스 적용
                                if (/\d/.test(part)) {
                                    return <span key={partIndex} className="c-black">&nbsp;{part}</span>;
                                } else {
                                    // 숫자가 아닌 문자열 부분은 기본 스타일 적용
                                    return <span key={partIndex}>{part}</span>;
                                }
                            });
                            return <div key={itemIndex}>{formattedParts}</div>;
                        })
                        : <span className="c-black">{zhValue}</span>; // 세미콜론이 없는 경우에는 기본적으로 c-black 적용

                    // 나머지 칼럼 데이터
                    return (
                        <div key={colIndex} className="td">
                        <span className="c-black">
                            {formattedZhValue}
                        </span>
                        </div>
                    );
                })}
            </div>
        ));
    };

    return (
        <>
            {!data.metadata || !data.records.length ?
                (
                    // TODO 수정 필요: 로딩 창이 작은 거가 문제 즉 디자인에 대한 문제
                    <div className="popup-cont" style={{display: "block" ,minWidth: "calc(100vw - 100px)", minHeight: "calc(100vh - 100px)" }}>
                        <div className="load-wrap">
                            <div className="load-box">
                                <div className="square" ></div>
                                <div className="square" ></div>
                                <div className="square" ></div>
                                <div className="square" ></div>
                            </div>
                        </div>
                    </div>
                )
                :
                (
                    <>
                        <div className="popup-header">
                            <b className="popup-title">
                                {data.metadata.tableau_title}
                                <span className="sub-tit">
                        {data.metadata.book_title} ({data.metadata.book_year}年 基準)
                    </span>
                            </b>
                            <button type="button" className="popup-close" onClick={backToToc}>
                                닫기
                            </button>
                        </div>
                        <div className="popup-cont">
                            <div className="table-wrap type-scroll-all">
                                <div className="scroll-table">
                                    {renderHeader()}
                                    <div className="scroll-row">
                                        {renderRows()}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                )
            }
        </>
    )
};

export default Tableau;